import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/general/Marquee.css';
import MyContext from '../../../contexts/AppContext';
import axios from 'axios';

const HomeMarquee = () => {
  const { baseUrl, baseUrlForFiles } = useContext(MyContext);
  const [marquees, setMarquees] = useState([]);
  const [isVisible, setIsVisible] = useState(true);
  const navigate = useNavigate();

  const viewAllMarquees = () => {
    axios.get(`${baseUrl}/customer/marquee/viewAllMarquees`)
      .then((response) => {
        console.log(response.data);
        setMarquees(response.data.marquee);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllMarquees();
  }, []);

  const handleMarqueeClick = (link) => {
    if (link) {
      // Navigate to categories page
      navigate(link);
    }
  };

  const handleClose = () => {
    setIsVisible(false);
    // Optional: Save to localStorage so it stays closed
    localStorage.setItem('marquee-closed', 'true');
  };

  // User ne close kiya ho toh hide
  if (!isVisible) {
    return null;
  }

  // Admin ne koi marquee create na kiya ho toh hide (ye asli fix hai)
  if (!marquees || marquees.length === 0) {
    return null;
  }

  // Create multiple copies for seamless loop
  // For single item, repeat it many times (at least 10-15 times for smooth scrolling)
  const repeatedMarquees = Array(15).fill(marquees).flat();

  return (
    <div className="home-marquee-wrapper">
      <div className="home-marquee-container">
        <div className="marquee-scroll">
          <div className="marquee-content">
            {repeatedMarquees.map((marquee, index) => (
              <span
                key={`${marquee.id}-${index}`}
                className="marquee-item"
                onClick={() => handleMarqueeClick(marquee.link)}
                style={{ cursor: 'pointer' }}
              >
                {marquee.marqueetext}
                <span className="marquee-separator">•</span>
              </span>
            ))}
          </div>
        </div>

        {/* Close Button */}
        {/* <button 
          className="marquee-close-btn"
          onClick={handleClose}
          aria-label="Close announcement"
        >
          <FiX size={16} />
        </button> */}
      </div>
    </div>
  );
};

export default HomeMarquee;